import React from 'react';
import { Link } from 'react-router';
import useTheme from '../hooks/useTheme';

interface PageHeroProps {
  title: string;
  subtitle: string;
  breadcrumbs?: Array<{ label: string; path?: string }>;
}

export const PageHero: React.FC<PageHeroProps> = ({ title, subtitle, breadcrumbs }) => {
  const { theme } = useTheme();
  return (
    <div
      style={{
        backgroundColor: theme.background.panel,
        borderBottom: `1px solid ${theme.colors.line}`,
        paddingTop: '80px',
        paddingBottom: '48px',
      }}
    >
      <div
        style={{
          maxWidth: '1120px',
          margin: '0 auto',
          padding: '0 20px',
        }}
      >
        {breadcrumbs && breadcrumbs.length > 0 && (
          <div
            style={{
              display: 'flex',
              gap: '8px',
              marginBottom: '16px',
              fontSize: '14px',
              color: theme.text.muted,
              flexWrap: 'wrap',
            }}
          >
            {breadcrumbs.map((crumb, idx) => (
              <React.Fragment key={idx}>
                {crumb.path ? (
                  <Link
                    to={crumb.path}
                    style={{
                      color: theme.text.muted,
                      textDecoration: 'none',
                    }}
                    className="breadcrumbLink"
                  >
                    {crumb.label}
                  </Link>
                ) : (
                  <span>{crumb.label}</span>
                )}
                {idx < breadcrumbs.length - 1 && <span> / </span>}
              </React.Fragment>
            ))}
          </div>
        )}
        <h1
          style={{
            fontSize: '46px',
            fontWeight: 700,
            color: theme.text.primary,
            marginBottom: '12px',
            lineHeight: 1.35,
          }}
          className="pageTitle"
        >
          {title}
        </h1>
        <p
          style={{
            fontSize: '18px',
            color: 'var(--muted)',
            lineHeight: 1.6,
          }}
        >
          {subtitle}
        </p>
      </div>
    </div>
  );
};

